/* Groove PDP — Shopify section interactions
 * - Inline SVG diagram fallbacks (rendered only when an image_picker
 *   override is NOT supplied; the Liquid section omits the [data-illo]
 *   wrapper if a merchant-provided image is present)
 * - Product gallery thumb switching (skipped when product.media is
 *   server-rendered — the section sets .gallery[data-server-rendered])
 * - FAQ accordion
 * - "Show more reviews" toggle
 * - Sticky mobile CTA scroll trigger
 */

(function () {

  // ============================================================
  // ILLUSTRATIONS — inline SVG fallbacks for diagrams
  // (only rendered when the section did not output an <img>)
  // ============================================================
  const ILLOS = {
    'pain-before': `
      <svg viewBox="0 0 320 220" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:auto;display:block">
        <rect width="320" height="220" fill="#F4F5F7"/>
        <line x1="0" y1="190" x2="320" y2="190" stroke="#14213D" stroke-width="1"/>
        <rect x="40" y="155" width="210" height="35" fill="#fff" stroke="#14213D" stroke-width="0.9"/>
        <circle cx="100" cy="122" r="20" fill="#D4A78A"/>
        <path d="M70 165 Q80 140 100 140 Q120 140 135 175 L135 190 L70 190 Z" fill="#14213D" opacity="0.55"/>
        <circle cx="130" cy="155" r="14" fill="#E9865E" opacity="0.35"/>
        <circle cx="130" cy="155" r="8" fill="#E9865E" opacity="0.65"/>
        <text x="160" y="158" font-size="9" font-weight="700" fill="#14213D">Shoulder Trap</text>
        <circle cx="115" cy="135" r="10" fill="#E9865E" opacity="0.3"/>
        <text x="160" y="138" font-size="9" font-weight="700" fill="#14213D">Neck strain</text>
      </svg>`,

    'pain-after': `
      <svg viewBox="0 0 320 220" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:auto;display:block">
        <rect width="320" height="220" fill="#EAF5EE"/>
        <line x1="0" y1="190" x2="320" y2="190" stroke="#14213D" stroke-width="1"/>
        <path d="M40 190 L40 155 Q40 138 70 135 L130 138 Q150 150 160 162 L200 162 Q250 162 250 178 L250 190 Z" fill="#fff" stroke="#14213D" stroke-width="0.9"/>
        <circle cx="100" cy="118" r="20" fill="#D4A78A"/>
        <path d="M70 165 Q80 140 100 140 Q120 140 132 165 L132 190 L70 190 Z" fill="#14213D" opacity="0.55"/>
        <text x="160" y="120" font-size="9" font-weight="700" fill="#2BA84A">Neutral neck</text>
        <text x="160" y="138" font-size="9" font-weight="700" fill="#2BA84A">Shoulder settles</text>
        <line x1="100" y1="100" x2="100" y2="190" stroke="#2BA84A" stroke-width="1" stroke-dasharray="2 2" opacity="0.6"/>
      </svg>`,

    'annotated': `
      <svg viewBox="0 0 720 360" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:auto;display:block">
        <defs>
          <linearGradient id="pAnnoGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stop-color="#FFFFFF"/>
            <stop offset="1" stop-color="#E9ECF1"/>
          </linearGradient>
        </defs>
        <rect width="720" height="360" fill="#F4F5F7"/>
        <ellipse cx="360" cy="295" rx="240" ry="10" fill="#14213D" opacity="0.08"/>
        <path d="M120 290 Q120 180 200 175 L290 178 Q310 195 325 215 Q345 230 360 220 Q375 230 395 215 Q410 195 430 178 L520 175 Q600 180 600 290 Z"
              fill="url(#pAnnoGrad)" stroke="#14213D" stroke-width="1.6"/>
        <path d="M325 215 Q345 232 360 222 Q375 232 395 215" fill="none" stroke="#14213D" stroke-width="0.8" opacity="0.3"/>
        <line x1="170" y1="270" x2="120" y2="320" stroke="#14213D" stroke-width="1"/>
        <circle cx="170" cy="270" r="3" fill="#2BA84A"/>
        <text x="80" y="335" font-size="13" font-weight="700" fill="#14213D">Shoulder Overhang</text>
        <text x="80" y="350" font-size="10" fill="#14213D" opacity="0.65">Where the shoulder settles in</text>
        <line x1="220" y1="200" x2="180" y2="100" stroke="#14213D" stroke-width="1"/>
        <circle cx="220" cy="200" r="3" fill="#2BA84A"/>
        <text x="40" y="90" font-size="13" font-weight="700" fill="#14213D">Raised Side Zone</text>
        <text x="40" y="105" font-size="10" fill="#14213D" opacity="0.65">Side-sleeper height, held all night</text>
        <line x1="360" y1="225" x2="380" y2="80" stroke="#14213D" stroke-width="1"/>
        <circle cx="360" cy="225" r="3" fill="#2BA84A"/>
        <text x="335" y="70" font-size="13" font-weight="700" fill="#14213D">Neck Contour</text>
        <text x="335" y="85" font-size="10" fill="#14213D" opacity="0.65">Cervical support on your back</text>
        <line x1="490" y1="200" x2="600" y2="100" stroke="#14213D" stroke-width="1"/>
        <circle cx="490" cy="200" r="3" fill="#2BA84A"/>
        <text x="545" y="90" font-size="13" font-weight="700" fill="#14213D">Face-Supporting Wing</text>
        <text x="545" y="105" font-size="10" fill="#14213D" opacity="0.65">Cheek lands, neck stays in line</text>
        <line x1="540" y1="270" x2="640" y2="320" stroke="#14213D" stroke-width="1"/>
        <circle cx="540" cy="270" r="3" fill="#2BA84A"/>
        <text x="580" y="335" font-size="13" font-weight="700" fill="#14213D">Bamboo Charcoal Foam</text>
        <text x="580" y="350" font-size="10" fill="#14213D" opacity="0.65">Slow-rebound, holds under load</text>
      </svg>`,

    'shoulder': `
      <svg viewBox="0 0 480 280" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:auto;display:block">
        <rect width="480" height="280" fill="#F4F5F7"/>
        <g>
          <text x="20" y="28" font-size="11" font-weight="700" fill="#14213D">FLAT PILLOW</text>
          <rect x="20" y="180" width="200" height="60" fill="#fff" stroke="#14213D" stroke-width="0.8"/>
          <line x1="0" y1="240" x2="240" y2="240" stroke="#14213D" stroke-width="1"/>
          <circle cx="80" cy="155" r="22" fill="#D4A78A"/>
          <path d="M50 200 Q60 175 80 175 Q100 175 110 200 L110 240 L50 240 Z" fill="#14213D" opacity="0.55"/>
          <circle cx="105" cy="200" r="14" fill="#E9865E" opacity="0.4"/>
          <circle cx="105" cy="200" r="8" fill="#E9865E" opacity="0.7"/>
          <text x="125" y="200" font-size="10" fill="#14213D" font-weight="700">Shoulder Trap</text>
          <text x="125" y="213" font-size="9" fill="#14213D" opacity="0.6">Neck compensates</text>
        </g>
        <g transform="translate(240,0)">
          <text x="20" y="28" font-size="11" font-weight="700" fill="#2BA84A">ORIGINAL GROOVE®</text>
          <path d="M20 240 L20 195 Q20 175 50 173 L100 175 Q120 188 130 200 L160 200 Q200 200 200 220 L200 240 Z"
                fill="#fff" stroke="#14213D" stroke-width="0.8"/>
          <line x1="0" y1="240" x2="240" y2="240" stroke="#14213D" stroke-width="1"/>
          <circle cx="80" cy="150" r="22" fill="#D4A78A"/>
          <path d="M50 195 Q60 170 80 170 Q100 170 112 195 L112 240 L50 240 Z" fill="#14213D" opacity="0.55"/>
          <circle cx="115" cy="220" r="10" fill="#2BA84A" opacity="0.35"/>
          <text x="130" y="220" font-size="10" fill="#14213D" font-weight="700">Shoulder settles</text>
          <text x="130" y="233" font-size="9" fill="#14213D" opacity="0.6">Neck stays neutral</text>
        </g>
      </svg>`,

    'two-positions': `
      <svg viewBox="0 0 480 280" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:auto;display:block">
        <rect width="480" height="280" fill="#F4F5F7"/>
        <g>
          <text x="20" y="28" font-size="11" font-weight="700" fill="#14213D">SIDE</text>
          <path d="M20 240 L20 200 Q20 178 50 175 L100 178 Q120 192 130 205 L170 205 Q210 205 210 225 L210 240 Z"
                fill="#fff" stroke="#14213D" stroke-width="0.8"/>
          <circle cx="80" cy="155" r="22" fill="#D4A78A"/>
          <path d="M50 200 Q60 175 80 175 Q100 175 110 205 L110 240 L50 240 Z" fill="#14213D" opacity="0.55"/>
          <line x1="0" y1="240" x2="240" y2="240" stroke="#14213D" stroke-width="1"/>
          <line x1="80" y1="135" x2="80" y2="240" stroke="#2BA84A" stroke-width="1.2" stroke-dasharray="3 3" opacity="0.7"/>
          <text x="130" y="170" font-size="10" fill="#14213D" font-weight="700">Spine in line</text>
        </g>
        <g transform="translate(240,0)">
          <text x="20" y="28" font-size="11" font-weight="700" fill="#14213D">BACK</text>
          <path d="M20 240 L20 215 Q20 198 50 195 L80 195 Q100 195 105 210 Q110 220 120 220 Q130 220 135 210 Q140 195 160 195 L190 195 Q210 198 210 215 L210 240 Z"
                fill="#fff" stroke="#14213D" stroke-width="0.8"/>
          <line x1="0" y1="240" x2="240" y2="240" stroke="#14213D" stroke-width="1"/>
          <circle cx="120" cy="180" r="20" fill="#D4A78A"/>
          <path d="M50 230 Q90 210 120 210 Q150 210 190 230 L190 240 L50 240 Z" fill="#14213D" opacity="0.55"/>
          <line x1="120" y1="160" x2="190" y2="240" stroke="#2BA84A" stroke-width="1.2" stroke-dasharray="3 3" opacity="0.7"/>
          <text x="60" y="170" font-size="10" fill="#14213D" font-weight="700">Cervical curve cradled</text>
        </g>
      </svg>`,

    'foam-cutaway': `
      <svg viewBox="0 0 480 280" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:auto;display:block">
        <rect width="480" height="280" fill="#F4F5F7"/>
        <text x="240" y="30" font-size="11" font-weight="700" fill="#14213D" text-anchor="middle">FOAM CUTAWAY · BAMBOO CHARCOAL CORE</text>
        <path d="M60 220 Q60 110 150 100 L330 100 Q420 110 420 220 L420 240 Q420 250 410 250 L70 250 Q60 250 60 240 Z"
              fill="#fff" stroke="#14213D" stroke-width="1.4"/>
        ${[...Array(8)].map((_, i) => `<line x1="${75 + i * 45}" y1="120" x2="${80 + i * 45}" y2="240" stroke="#14213D" stroke-width="0.4" opacity="0.18"/>`).join('')}
        <path d="M180 130 Q180 170 200 200 Q240 240 280 200 Q300 170 300 130 Z" fill="#3F4A57" opacity="0.92"/>
        ${[...Array(40)].map(() => {
          const x = 185 + Math.random() * 110;
          const y = 135 + Math.random() * 90;
          const r = Math.random() * 1.2 + 0.4;
          const o = (0.6 + Math.random() * 0.4).toFixed(2);
          return `<circle cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(2)}" fill="#1c2229" opacity="${o}"/>`;
        }).join('')}
        <line x1="240" y1="100" x2="240" y2="60" stroke="#14213D" stroke-width="1"/>
        <text x="240" y="55" font-size="10" font-weight="700" fill="#14213D" text-anchor="middle">Quilted breathable cover</text>
        <line x1="240" y1="170" x2="430" y2="170" stroke="#14213D" stroke-width="1"/>
        <text x="430" y="170" font-size="10" font-weight="700" fill="#14213D" text-anchor="end" dy="-4">Slow-rebound bamboo charcoal foam</text>
        <text x="430" y="185" font-size="9" fill="#14213D" opacity="0.6" text-anchor="end">Holds shape under sustained load</text>
      </svg>`
  };

  function renderIllos() {
    document.querySelectorAll('[data-illo]').forEach(el => {
      if (el.children.length > 0) return; // merchant-supplied image already rendered
      const key = el.getAttribute('data-illo');
      if (ILLOS[key]) el.innerHTML = ILLOS[key];
    });
  }

  // ============================================================
  // GALLERY — placeholder fallback when no product media is wired
  // ============================================================
  function galleryAngleSvg(v) {
    const bg = v === 1 ? "#E9ECF1" : v === 3 ? "#EEF0F3" : "#F4F5F7";
    const inner = ({
      0: `<ellipse cx="50" cy="72" rx="40" ry="5" fill="#14213D" opacity="0.1"/>
          <path d="M14 70 Q14 44 28 42 L44 44 Q49 50 52 54 Q55 50 60 44 L76 42 Q86 44 86 70 L86 76 Q86 80 82 80 L18 80 Q14 80 14 76 Z" fill="#fff" stroke="#14213D" stroke-width="1"/>
          <path d="M52 54 Q55 60 58 54" fill="none" stroke="#14213D" stroke-width="0.6" opacity="0.3"/>`,
      1: `<rect x="6" y="55" width="88" height="40" fill="#fff" stroke="#14213D" stroke-width="0.5"/>
          <path d="M16 70 Q16 50 30 48 L48 52 Q54 58 58 64 Q62 58 68 52 L86 48 Q94 50 94 70" fill="#fff" stroke="#14213D" stroke-width="0.8"/>`,
      2: `<ellipse cx="50" cy="80" rx="42" ry="4" fill="#14213D" opacity="0.08"/>
          <path d="M10 78 Q10 60 24 58 L40 60 Q46 66 50 70 Q54 66 60 60 L76 58 Q90 60 90 78 Z" fill="#fff" stroke="#14213D" stroke-width="0.7"/>
          <circle cx="42" cy="50" r="9" fill="#D4A78A"/>
          <path d="M30 68 Q30 60 42 58 Q54 60 56 68 Q56 76 46 76 Z" fill="#14213D" opacity="0.55"/>`,
      3: `<ellipse cx="50" cy="48" rx="38" ry="22" fill="#fff" stroke="#14213D" stroke-width="0.7"/>
          <ellipse cx="50" cy="44" rx="34" ry="6" fill="none" stroke="#14213D" stroke-width="0.4" opacity="0.4"/>
          <circle cx="50" cy="40" r="10" fill="#E8B89A"/>`,
      4: `<rect x="10" y="62" width="80" height="22" fill="#fff" stroke="#14213D" stroke-width="0.5"/>
          <path d="M16 70 Q16 56 30 54 L46 56 Q52 62 56 66 Q60 62 66 56 L82 54 Q92 56 92 70" fill="#fff" stroke="#14213D" stroke-width="0.8"/>
          <text x="50" y="22" font-size="6" fill="#14213D" text-anchor="middle" font-weight="700" letter-spacing="1">CHIROPRACTOR-RECOMMENDED</text>
          <line x1="20" y1="28" x2="80" y2="28" stroke="#14213D" stroke-width="0.4" opacity="0.4"/>`
    })[v] || '';
    return `<svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:100%;display:block"><rect width="100" height="100" fill="${bg}"/>${inner}</svg>`;
  }

  function initGallery() {
    const gallery = document.querySelector('.gallery[data-groove-gallery]');
    if (!gallery) return;
    const main = gallery.querySelector('.gallery-main');
    const thumbs = gallery.querySelector('.gallery-thumbs');
    if (!main || !thumbs) return;

    const serverRendered = gallery.dataset.serverRendered === 'true';

    if (serverRendered) {
      // Real product.media — wire click handlers on existing thumbs
      thumbs.addEventListener('click', e => {
        const btn = e.target.closest('.gallery-thumb');
        if (!btn) return;
        const src = btn.dataset.full;
        const alt = btn.dataset.alt || '';
        if (!src) return;
        thumbs.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
        btn.classList.add('active');
        main.innerHTML = `<img src="${src}" alt="${alt}" loading="eager"/>`;
      });
      return;
    }

    // No product wired — render the inline SVG placeholder gallery
    main.innerHTML = galleryAngleSvg(0);
    thumbs.innerHTML = [0, 1, 2, 3, 4].map(i =>
      `<button type="button" class="gallery-thumb${i === 0 ? ' active' : ''}" data-i="${i}" aria-label="View image ${i + 1}">${galleryAngleSvg(i)}</button>`
    ).join('');
    thumbs.addEventListener('click', e => {
      const btn = e.target.closest('.gallery-thumb');
      if (!btn) return;
      const i = parseInt(btn.dataset.i, 10);
      thumbs.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
      btn.classList.add('active');
      main.innerHTML = galleryAngleSvg(i);
    });
  }

  // ============================================================
  // FAQ accordion
  // ============================================================
  function initFAQ() {
    document.querySelectorAll('.faq-item .faq-q').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.faq-item');
        const wasOpen = item.classList.contains('open');
        document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
        if (!wasOpen) item.classList.add('open');
      });
    });
  }

  // ============================================================
  // Show more reviews
  // ============================================================
  function initShowMore() {
    const btn = document.getElementById('show-more-btn');
    if (!btn) return;
    btn.addEventListener('click', () => {
      document.querySelectorAll('.extra-review').forEach(el => el.hidden = false);
      const wrap = document.getElementById('show-more-wrap');
      if (wrap) wrap.style.display = 'none';
    });
  }

  // ============================================================
  // Sticky mobile CTA — scroll-based, only appears after the user
  // has actually scrolled past the hero. Earlier IntersectionObserver
  // approach fired pastTop=true on initial load when the sentinel
  // was below the fold, making the sticky CTA visible in the ATF.
  // ============================================================
  function initStickyCTA() {
    const sticky = document.getElementById('sticky-cta');
    if (!sticky) return;
    document.body.classList.add('has-groove-pdp-sticky');

    const sentinelTop = document.querySelector('[data-sticky-sentinel="top"]');

    function update() {
      const y = window.scrollY || window.pageYOffset || 0;
      const max = document.body.scrollHeight - window.innerHeight - 200;
      // Threshold: top sentinel's position OR 800px (whichever exists).
      let threshold = 800;
      if (sentinelTop) {
        const r = sentinelTop.getBoundingClientRect();
        threshold = Math.max(threshold - 1, r.top + y - window.innerHeight + 1);
      }
      const visible = y > threshold && y < max;
      sticky.classList.toggle('visible', visible);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    // Defer initial run so we don't trigger before layout settles
    requestAnimationFrame(update);
  }

  // ============================================================
  // Init
  // ============================================================
  function init() {
    renderIllos();
    initGallery();
    initFAQ();
    initShowMore();
    initStickyCTA();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
